import { InjectionToken } from '@angular/core';

export const GOOGLE_ANALYTICS_PREVIEW = new InjectionToken<string>('Google Analytics preview ID specific for each environment');
